import { Service } from "../Service";

const pagegrowlerFrontendApiUrl =
  process.env.PAGEGROWLER_FRONTEND_API ??
  process.env.NEXT_PUBLIC_PAGEGROWLER_FRONTEND_API;

export class Propiedades extends Service {
  constructor() {
    super({
      adsPath: "servicios/divisas",
      meta: {
        description: `Calculadora de alquileres - Clarín.com`,
        keywords: "calculadora, alquileres",
        title: `Calculadora de alquileres`,
        url: `propiedades/calculadora-alquileres`,
        extra: [],
      },
      section: "propiedades",
      sectionAds: "calculadora-alquileres",
      template: "CalculatorRentals",
      title: `Calculadora de alquileres`,
      titleHeader: "",
      slug: "propiedades",
      breadcrumb: [
        {
          title: "Propiedades",
          url: "/propiedades",
        },
        {
          title: "Calculadora de alquileres",
          url: "",
        },
      ],
      showTitleHeaderApp: false,
      showMenuApp: false,
      showBreadcrumbApp: false,
      showBannerH1App: false,
    });
  }

  parseData = async () => {
    const slug = this.getSlug();
    const notes = await this.fetchData(
      `${pagegrowlerFrontendApiUrl}lilanews/?type=listType&tag=${slug}&limit=6`
    );

    this.setData({
      notes: notes?.data?.content ?? [],
    });
  };
}
